import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import {createAuthSlice} from "./Slices/authSlice";
import {createInvoiceSlice} from "./Slices/invoiceSlice";
import {createPerformanceStatementsSlice} from "./Slices/performancestatementsSlice";
import {createShiftSlice} from "./Slices/shiftSlice";
import {createApplicationSlice} from "./Slices/applicationSlice";
import {createRegistrationSlice} from "./Slices/registrationSlice";
import {createContractSlice} from "./Slices/contractSlice";
import {createCustomerSlice} from "./Slices/customerSlice";
import {createFreelancerSlice} from "./Slices/freelancerSlice";
import {createStatisticsSlice} from "./Slices/statisticsSlice";
import {createExportExcelSlice} from "./Slices/excelExportSlice";
import {createAvailabilitySlice} from "./Slices/availabilitySlice";
import {createBranchSlice} from "./Slices/branchSlice";
import {createContractTypeSlice} from "./Slices/contractTypeSlice";
import {createMailHistorySlice} from "./Slices/MailHistorySlice";
import {createBranchPercentageSlice} from "./Slices/branchPercentageSlice";
import {createExceptionRateSlice} from "./Slices/exceptionRateSlice";

export const useBoundStore = create(
    persist(
        (set, get, api) => ({
            ...createAuthSlice(set, get, api),
            ...createInvoiceSlice(set, get, api),
            ...createPerformanceStatementsSlice(set, get, api),
            ...createShiftSlice(set, get, api),
            ...createApplicationSlice(set, get, api),
            ...createRegistrationSlice(set, get, api),
            ...createContractSlice(set, get, api),
            ...createCustomerSlice(set, get, api),
            ...createFreelancerSlice(set, get, api),
            ...createStatisticsSlice(set, get, api),
            ...createExportExcelSlice(set, get, api),
            ...createAvailabilitySlice(set, get, api),
            ...createBranchSlice(set, get, api),
            ...createContractTypeSlice(set, get, api),
            ...createMailHistorySlice(set, get, api),
            ...createBranchPercentageSlice(set, get, api),
            ...createExceptionRateSlice(set, get, api),
        }),
        {
            name: 'ccp-store',
            partialize: (state) => ({
                isAuthenticated: state.isAuthenticated,
                accessToken: state.accessToken,
                refreshToken: state.refreshToken,
                user: state.user,
            }),
        }
    )
)
